module.exports = __webpack_public_path__ + "static/media/classroom.207af25a.png";